// extracted by mini-css-extract-plugin
export var carouselContainer = "onScreenCarousel-module--carouselContainer--5d595";
export var cursor = "onScreenCarousel-module--cursor--9ef07";
export var eventLink = "onScreenCarousel-module--eventLink--cf7d5";
export var heading = "onScreenCarousel-module--heading--faf07";
export var image = "onScreenCarousel-module--image--04833";
export var padding = "onScreenCarousel-module--padding--33aec";
export var slider = "onScreenCarousel-module--slider--706b4";
export var tagContainer = "onScreenCarousel-module--tagContainer--432f3";
export var tileOverlay = "onScreenCarousel-module--tileOverlay--5ae26";
export var videoContainer = "onScreenCarousel-module--videoContainer--31d56";
export var videoInfo = "onScreenCarousel-module--videoInfo--bd162";